import { WpProvider } from './wp-provider.model';
import {WpEmpAssessment} from './wp-emp-assessment.model';

export class WpTraining {
  constructor(
    public id ?: number, /*NOT NULL AUTO_INCREMENT,*/
    public referralId ?: string, /*NOT NULL,*/
    public trainingEndDt?: any,
    public trainingName?: string, /*NOT NULL,*/
    public trainingStartDt?: any, /*NOT NULL,*/
    public trainingType?: string, /*NOT NULL,*/
    public  createdBy?: string,
    public wpEmpAssessment?: WpEmpAssessment
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/wp-training.model.ts